var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it"},[_c('backgroundit'),_c('navbar'),_c('approach-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }